import MultiRangeSlider from './MultiRangeSlider'

export default MultiRangeSlider
